import Vue from 'vue';
import VueAlertify from 'vue-alertify';
import router from './router'
import App from './App'

Vue.use(VueAlertify)

function unauthorized(code) {
  if (code == 401) {
    var vm = new Vue({
      el: '#app',
      router,
      mounted: function(){
        this.$alertify.error('Login session expired')
        localStorage.removeItem('permissiondata');
        localStorage.removeItem('userdetail');
        localStorage.removeItem('userToken');
        localStorage.removeItem('isLoggedIn');
        this.$router.push('/login');
      }
    })
  }
}


export default {
  unauthorized
}



// WEBPACK FOOTER //
// ./src/unauthorizedres.js